import { createSlice } from "@reduxjs/toolkit";
import { fetchCustomers } from "./customersDuck";
import devicesReducer, { devicesDefaultState } from "../../src/Dashboard/ducks/devicesDuck";
import samplesReducer, { samplesDefaultState } from "../../src/Dashboard/ducks/samplesDuck";
import alarmsReducer, { alarmsDefaultState } from "../../src/Dashboard/ducks/alarmsDuck";
import socketReducer, { socketDefaultState } from "../../src/Dashboard/ducks/socketDuck";

const REALTIME_CROSS_TIER = new Set([
  "devicesConfigs/fetchDevicesConfigs/fulfilled",
  "system/getConfig",
]);

const isRealtimeAction = (action) => {
  const systemId = action.payload?.systemId || action.meta?.arg?.systemId;
  if (!systemId) return false;
  const t = action.type;
  return (
    t.startsWith("devices/") ||
    t.startsWith("samples/") ||
    t.startsWith("alarms/") ||
    t.startsWith("socket/") ||
    REALTIME_CROSS_TIER.has(t)
  );
};

const realtimeTierSlice = createSlice({
  name: "realtime",
  initialState: {},
  reducers: {
    initializeDeviceRealtime(state, action) {
      const { systemId } = action.payload;
      if (!state[systemId] || !state[systemId]._initialized) {
        state[systemId] = {
          devices: devicesDefaultState,
          samples: samplesDefaultState,
          alarms: alarmsDefaultState,
          socket: socketDefaultState,
          _initialized: true,
        };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        const systems = [];
        action.payload.length > 0 &&
          action.payload.forEach((customer) => systems.push(...customer.devices));
        systems.forEach((sys) => {
          if (!state[sys.deviceId]) {
            state[sys.deviceId] = { _initialized: false };
          }
        });
      })
      .addMatcher(isRealtimeAction, (state, action) => {
        const systemId = action.payload?.systemId || action.meta?.arg?.systemId;
        if (systemId && state[systemId]?._initialized) {
          state[systemId].devices = devicesReducer(state[systemId].devices, action);
          state[systemId].samples = samplesReducer(state[systemId].samples, action);
          state[systemId].alarms = alarmsReducer(state[systemId].alarms, action);
          state[systemId].socket = socketReducer(state[systemId].socket, action);
        }
      });
  },
});

export const { initializeDeviceRealtime } = realtimeTierSlice.actions;
export default realtimeTierSlice.reducer;
